import { render, staticRenderFns } from "./FooterWrapper.vue?vue&type=template&id=ba4feda8&"
import script from "./FooterWrapper.vue?vue&type=script&lang=js&"
export * from "./FooterWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports